export const formatError =
  (fieldName: string) =>
  (error: unknown): string => {
    if (error && typeof error === 'object') {
      if (fieldName in error) {
        return (error as Record<string, unknown>)[fieldName] as string;
      }
    }

    return error as string;
  };
